module.exports = __webpack_public_path__ + "static/media/Minho.9f90c712.svg";